const GET_BREADCRUMBS_LIST = "GET_BREADCRUMBS_LIST";
const GET_DATA_LIST = "GET_DATA_LIST";
const GET_TABLE_HEADER_LIST = "GET_TABLE_HEADER_LIST";
const GET_USER_NAME = "GET_USER_NAME";
const GET_USER_ID = "GET_USER_ID";
const GET_USER_LOGO = "GET_USER_LOGO";
const GET_ENTITY_ID = "GET_ENTITY_ID";
const GET_NOTIFICATION = "GET_NOTIFICATION";
const GET_CONNECTION = "GET_CONNECTION";
const GET_EMAIL = "GET_EMAIL";
const GET_USER_ROLE = "GET_USER_ROLE";
const GET_NEW_CONTACT_EMAIL = "GET_NEW_CONTACT_EMAIL";
const GET_PROJECT_CLONE = "GET_PROJECT_CLONE";

let initialState = {
    breadcrumbsListValues: [],
    dataListValues: [],
    headerListValues: [],
    userName: '',
    userId:'',
    url:'',
    id: '',
    notification:'',
    connection: null,
    email:'',
    role: null,
    contactEmail: '',
    isProjectCloned: false
}

function reducer(state = initialState, action) {
    switch(action.type) {
        case GET_BREADCRUMBS_LIST:
            return ({
                ...state,
                breadcrumbsListValues: action.breadcrumbsList
            });
        case GET_DATA_LIST:
            return ({
                ...state,
                dataListValues: action.dataList
            });
        case GET_TABLE_HEADER_LIST:
            return ({
                ...state,
                headerListValues: action.headerList
            });
        case GET_USER_NAME:
            return ({
                ...state,
                userName: action.name
            });
        case GET_USER_ID:
            return ({
                ...state,
                userId: action.id
            });
        case GET_USER_LOGO:
        return ({
            ...state,
            url: action.url
        });
        case GET_ENTITY_ID:
        return ({
            ...state,
            id: action.id
        });
        case GET_NOTIFICATION:
            return ({
                ...state,
                notification: action.notification
            });
        case GET_CONNECTION:
            return ({
                ...state,
                connection: action.connection
            });
        case GET_EMAIL:
            return ({
                ...state,
                email: action.email
            });
        case GET_USER_ROLE:
            return ({
                ...state,
                role: action.role
            });
        case GET_NEW_CONTACT_EMAIL:
            return ({
                ...state,
                contactEmail: action.contactEmail
            });
        case GET_PROJECT_CLONE:
            return ({
                ...state,
                isProjectCloned: action.isProjectCloned
            });
        default:
            return state;
    }
}

export default reducer;